import { EApi } from '../interfaces/BaseApiResponse';

export const PRE_SIGNUP = {
  url: '/v1.0/config/preSignUp',
  en: EApi.FETCH_PRE_SIGN_UP_APP_CONFIG,
};
export const REFRESH_TOKEN = {
  url: '/v1.0/refreshToken',
  en: '' as EApi,
};
export const REQUEST_SIGNUP_OTP = {
  url: '/v1.0/user/requestSignupOtp',
  en: EApi.REQUEST_SIGNUP_OTP,
};
export const AUTHENTICATE_USER = {
  url: '/v1.0/auth/authenticateUser',
  en: EApi.AUTHENTICATE_USER,
};
export const USER_DETAILS = {
  url: '/v1.0/user/getUserDetails',
  en: EApi.GET_USER_DETAILS,
};
export const REGISTER_TOURNAMENTS = {
  url: '/v1.0/super/tournament/registerTournament',
  en: EApi.REGISTER_TOURNAMENT
}
export const SET_USER_LOCATION = {
  url: '/v1.0/user/setLocation',
  en: EApi.SET_USER_LOCATION
}
export const GET_WINNING_BANNER = {
  url: 'v1.0/super/postGamePlay/pwaWD',
  en: EApi.GET_PWA_POST_GAME_WD_DATA_EVENT
}
export const GET_PLAN_STATE_V3 = {
  url: '/v1.0/userSubscription/getPlanStateV3',
  en: EApi.GET_PLAN_STATE_V3
}
export const INITIATE_SUBSCRIPTION_CHECKOUT = {
  url: '/v1.0/payment/initiateSubscriptionCheckout',
  en: EApi.INITIATE_SUBSCRIPTION_CHECKOUT
}
export const CREATE_CHECKOUT_ORDER = {
  url: '/v1.0/payment/v3/checkoutOrder/create',
  en: EApi.CREATE_CHECKOUT_ORDER
}
export const PHONEPE_CHECKOUT_PAY = {
  url: '/v1.0/payment/phonepe/checkout',
  en: EApi.PHONEPE_CHECKOUT_PAY
}
export const GET_SUBSCRIPTION_STATUS = {
  url: '/v1.0/userSubscription/getSubscriptionStatus',
  en: EApi.SUBSCRIPTION_POLLING
}
export const GET_ORDER_STATUS = {
  url: '/v1.0/payment/order/status/deposit',
  en: EApi.GET_ORDER_STATUS
}